var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useField, useFormikContext } from "formik";
import React from "react";
export var FormItemSelect = function (_a) {
    var name = _a.name, label = _a.label, options = _a.options, tooltip = _a.tooltip;
    var _b = useFormikContext(), submitForm = _b.submitForm, setFieldValue = _b.setFieldValue;
    var _c = __read(useField(name), 2), field = _c[0], meta = _c[1];
    var touched = meta.touched, error = meta.error;
    var selectedValue = field.value;
    var errorText = touched && error ? error : null;
    var handleChange = function (value) {
        setFieldValue(name, value);
        // submitForm();
    };
    return (React.createElement("div", { className: "form-item-select" },
        React.createElement("div", { className: "form-item-select__label_box" },
            React.createElement("label", { className: "form-item-select__label" }, label),
            tooltip ? (React.createElement("div", { className: "form-item-select__tooltip" },
                "i",
                React.createElement("div", { className: "form-item-select__tooltip_window tooltip" }, tooltip))) : (React.createElement(React.Fragment, null))),
        React.createElement("select", { className: "form-item-select__control", 
            // id={`${name}_${value}`}
            name: name, onChange: function (event) { return handleChange(event.target.value); } },
            React.createElement("option", { className: "form-item-select__option", value: "", selected: selectedValue === null, disabled: true }, "-- Vyberte program podpory --"),
            options.map(function (_a) {
                var value = _a.value, label = _a.label;
                return (React.createElement("option", { key: value, className: "form-item-select__option", value: value, selected: selectedValue === value }, label));
            })),
        errorText && (React.createElement("div", { className: "form-item-textarea__error scroll_to_error" }, errorText))));
};
